import { render, staticRenderFns } from "./proyectoPrioridades.vue?vue&type=template&id=72efaf08&scoped=true&"
import script from "./proyectoPrioridades.vue?vue&type=script&lang=ts&"
export * from "./proyectoPrioridades.vue?vue&type=script&lang=ts&"
import style0 from "./proyectoPrioridades.vue?vue&type=style&index=0&id=72efaf08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72efaf08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCardActions,VCol,VDialog,VIcon,VRow,VSpacer,VTextField,VToolbar,VToolbarTitle})
